// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { defineComponent, h, type MaybeRef, unref } from 'vue';
import { useConfirm } from 'primevue/useconfirm';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';

export const useConfirmUnsavedChanges = (shouldShowWarning: (() => boolean) | MaybeRef<boolean>, onClose: () => void, type: 'dialog' | 'popup' = 'popup') => {
  const confirm = useConfirm();
  const group = crypto.randomUUID();

  const onClick = (e?: MouseEvent) => {
    // const showDialog = typeof shouldShowWarning === 'function'
    //   ? shouldShowWarning()
    //   : unref(shouldShowWarning);

    // if (!showDialog) {
    //   onClose();
    //   return;
    // }

    confirm.require({
      accept: onClose,
      group,
      target: e?.currentTarget as HTMLElement,
      header: 'Unsaved Changes',
      message: 'Any unsaved changes you may have will be lost if you cancel. Are you sure you want to close?',
      // message: 'You have unsaved changes that will be lost if you cancel. Are you sure you want to close?',
      icon: 'pi pi-exclamation-circle',
      acceptLabel: 'Close',
      rejectLabel: 'Keep working',
      acceptProps: {
        severity: 'secondary',
        variant: 'outlined',
        size: 'small',
      },
      rejectProps: {
        variant: 'outlined',
        size: 'small',
      },
    });
  };

  const DialogWrapper = defineComponent({
    setup() {
      return type === 'dialog'
        ? () => h(ConfirmDialog, { group })
        : () => h(ConfirmPopup, { group });
    },
  });

  return {
    component: DialogWrapper,
    onClick,
  };
};
